import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=56ddb520"
import script from "./Questions.vue?vue&type=script&lang=ts"
export * from "./Questions.vue?vue&type=script&lang=ts"
import style0 from "./Questions.vue?vue&type=style&index=0&id=56ddb520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports